import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
    return (
        <div className="min-h-screen" style={{background: 'linear-gradient(135deg, var(--app-color), #8B5CF6)'}}>
            {/* Header */}
            <header className="bg-white/90 backdrop-blur-sm border-b border-white/20">
                <div className="max-w-6xl mx-auto px-4 py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{background: 'var(--app-color)'}}>
                                <span className="text-white font-bold text-lg">E</span>
                            </div>
                            <h1 className="text-xl font-bold text-gray-900">Esti.kz</h1>
                        </div>
                        <Link 
                            to="/" 
                            className="text-sm font-medium px-4 py-2 rounded-lg transition-all duration-200 hover:scale-105 active:scale-95 flex items-center gap-2"
                            style={{background: 'var(--app-color)', color: 'white'}}
                        >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                            </svg>
                            Басты бетке оралу
                        </Link>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="max-w-4xl mx-auto px-4 py-8">
                <div className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-6 border border-white/20 mb-6">
                    <h1 className="text-3xl font-bold mb-6 text-gray-900">Құпиялылық саясаты</h1>

                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Бұл құпиялылық саясаты <a href="https://esti.kz" className="font-medium transition-colors hover:opacity-80" style={{color: 'var(--app-color)'}}>https://esti.kz</a> веб-сайтының
                        пайдаланушыларынан қандай ақпараттар жинайтынын, оларды қалай қолданатынын және
                        қауіпсіз түрде сақтайтынын түсіндіреді.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">1. Жиналатын ақпарат</h2>
                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Біз тек қажетті ақпаратты жинаймыз, оның ішінде:
                        <ul className="list-disc pl-6 mt-2 space-y-1 text-gray-700">
                            <li>Құрылғы және браузер деректері</li>
                            <li>Қолданушының әрекеттері мен өзара байланысы</li>
                        </ul>
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">2. Ақпаратты пайдалану</h2>
                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Жиналған ақпарат:
                        <ul className="list-disc pl-6 mt-2 space-y-1 text-gray-700">
                            <li>Қызмет көрсету сапасын жақсарту</li>
                            <li>Қауіпсіздікті қамтамасыз ету</li>
                            <li>Қолданушы сұраныстарына жауап беру үшін</li>
                        </ul>
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">3. Ақпаратты бөлісу</h2>
                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Сіздің ақпаратыңыз ешбір үшінші тараппен бөліспейміз, тек заң бойынша міндетті жағдайда немесе қауіпсіздік себептерімен ғана.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">4. Қауіпсіздік</h2>
                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Деректеріңізді қорғау үшін заманауи техникалық және әкімшілік қауіпсіздік шараларын қолданамыз.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">5. Cookie файлдары</h2>
                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Біздің сайт cookie файлдарын пайдаланады. Олар қолданушы тәжірибесін жақсартуға көмектеседі.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">6. Пайдаланушы құқықтары</h2>
                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Сіз өзіңіздің деректеріңізді қарау, өзгерту немесе өшіру құқығына иесіз. Ол үшін төмендегі байланысқа жазыңыз.
                    </p>

                    <h2 className="text-xl font-semibold mt-6 mb-3 text-gray-900">7. Байланыс</h2>
                    <p className="mb-4 text-gray-700 leading-relaxed">
                        Құпиялылық саясатына қатысты сұрақтарыңыз болса, бізге <a href="mailto:musaaldanazarov@gmail.com" className="font-medium transition-colors hover:opacity-80" style={{color: 'var(--app-color)'}}>musaaldanazarov@gmail.com</a> поштасы арқылы хабарласыңыз.
                    </p>
                </div>
            </main>

            {/* Footer */}
            <footer className="bg-white/10 backdrop-blur-sm border-t border-white/20 py-6 mt-8">
                <div className="max-w-6xl mx-auto px-4">
                    <div className="text-center">
                        <p className="text-white/80 text-sm">
                            © {new Date().getFullYear()} Esti.kz. Барлық құқықтар қорғалған.
                        </p>
                        <p className="text-xs text-white/60 mt-1">
                            Отбасы хрестоматиясы
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default PrivacyPolicy;